import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-first",
  "use": "icon-first-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-first\"><defs><style>#icon-first .a{fill:currentColor;}#icon-first .b{fill:#fff;font-size:16px;font-family:Helvetica;}</style></defs><g transform=\"translate(-5324.1 -178.947)\"><circle class=\"a\" cx=\"16\" cy=\"16\" r=\"16\" transform=\"translate(5324.1 178.947)\" /><text class=\"b\" transform=\"translate(5335.819 200)\"><tspan x=\"0\" y=\"0\">1</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol